import { type GotoNotificationChannel } from '@goto/shell-notification-channel'
import { ShellNotificationDefaultDispatcher } from './shell-notification-default-dispatcher'
import { getExternalInterface } from '../../external-interface'
import { ShellNotificationIntegrationDispatcher } from './shell-notification-integration-dispatcher'
import { ShellNotificationCompanionDispatcher } from './shell-notification-companion-dispatcher'

export const createNotificationDispatcher = (
  notificationChannel: GotoNotificationChannel,
): ShellNotificationDefaultDispatcher => {
  if (getExternalInterface().isIntegration) {
    return new ShellNotificationIntegrationDispatcher(notificationChannel)
  }
  if (getExternalInterface().isCompanion) {
    return new ShellNotificationCompanionDispatcher(notificationChannel)
  }

  return new ShellNotificationDefaultDispatcher(notificationChannel)
}
